import "./Dashboard.css";

/**
 * Error state component for SchoolAdminDashboard
 * Displays an error message with a refresh button to retry data fetching
 *
 * @param {Object} props
 * @param {string} props.error - The error message to display
 * @param {Function} props.onRefresh - Callback function to retry data fetching
 */
const DashboardErrorState = ({ error, onRefresh }) => {
  return (
    <div className="dashboard-error-container">
      <div className="dashboard-error-content">
        <div className="dashboard-error-icon">
          <i className="bi bi-exclamation-triangle-fill"></i>
        </div>
        <h3 className="dashboard-error-title">Oops! Something went wrong</h3>
        <p className="dashboard-error-message">
          {error || "We couldn't load the dashboard data. Please try again."}
        </p>
        <button
          className="dashboard-btn dashboard-error-btn"
          onClick={onRefresh}
        >
          <i className="bi bi-arrow-clockwise me-2"></i>
          Refresh
        </button>
      </div>

      <style>{`
        .dashboard-error-container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          padding: 40px 20px;
        }
        .dashboard-error-content {
          text-align: center;
          max-width: 400px;
        }
        .dashboard-error-icon {
          font-size: 64px;
          color: #ef4444;
          margin-bottom: 20px;
        }
        .dashboard-error-icon i {
          animation: error-shake 0.5s ease-in-out;
        }
        .dashboard-error-title {
          font-size: 22px;
          font-weight: 600;
          color: #1E1D38;
          margin-bottom: 12px;
        }
        .dashboard-error-message {
          font-size: 14px;
          color: #666;
          margin-bottom: 24px;
          line-height: 1.5;
        }
        .dashboard-error-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 28px;
          font-size: 15px;
          font-weight: 500;
          transition: all 0.3s ease;
        }
        .dashboard-error-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 142, 244, 0.3);
        }
        .dashboard-error-btn i {
          font-size: 18px;
        }
        @keyframes error-shake {
          0%, 100% {
            transform: translateX(0);
          }
          10%, 30%, 50%, 70%, 90% {
            transform: translateX(-5px);
          }
          20%, 40%, 60%, 80% {
            transform: translateX(5px);
          }
        }
        @media (max-width: 768px) {
          .dashboard-error-container {
            min-height: 300px;
            padding: 30px 15px;
          }
          .dashboard-error-icon {
            font-size: 48px;
          }
          .dashboard-error-title {
            font-size: 18px;
          }
          .dashboard-error-message {
            font-size: 13px;
          }
          .dashboard-error-btn {
            width: 100%;
            padding: 14px 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default DashboardErrorState;
